import { SET_CURRENT_USER } from "../Actions/types";

const initialState = {
  isAuthenticated: false,
  user: {},
  additional_information: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: isEmpty(action.payload),
        user: action.payload,
      };
    case "SET_ADDITIONAL_INFO":
      return {
        ...state,
        additional_information: {
          ...state.additional_information,
          ...action.payload,
        },
      };
    default:
      return state;
  }
}

const isEmpty = (obj) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return true;
  }
  return false;
};
